// extracted by mini-css-extract-plugin
export default {"filterSelector":"FilterSelector_filterSelector__cY1YR"};